// extracted by mini-css-extract-plugin
export default {"banner":"modal_banner__CZXeC","text":"modal_text__pZpVT","link":"modal_link__L5P7B","button":"modal_button__2ho27"};